import { put, select } from 'redux-saga/effects';
import { call } from 'ramda';
import * as Sentry from '@sentry/react';
import { roundStateSelector } from 'core/widgets/RoundStates';
import { IRoundState, RoundStates } from 'core/widgets/RoundStates/types';
import { setTotalBetAction } from 'core/widgets/User/actions';
import { totalBetSelector } from 'core/widgets/User';
import {
  ICreatePendingBetRequestData,
  ICreatePendingBetResponseData,
  RestService,
} from 'services/RestAPIService';
import { BetType, IBets, IConfirmedBet } from '../types';
import {
  getBetSum,
  buildTruncatedBetPayload,
  betsObjToConfirmedBets,
  confirmedBetsToObj,
  filterEmptyBets,
} from '../utils';
import { clearAllBetsAction, updatePlacedBetsAction } from '../actions';
import { isCommissionModeSelector } from '../CommissionMode';

export function* updateBetsSaga({ past, present }: IBets) {
  yield put(updatePlacedBetsAction({ past, present }));

  const isCommissionMode: boolean = yield select(isCommissionModeSelector);

  const truncatedBet: BetType = buildTruncatedBetPayload(present);
  yield call(createPendingBetSaga, {
    bets: betsObjToConfirmedBets(truncatedBet, isCommissionMode),
  });
}

export function* createPendingBetSaga({ bets }: { bets: IConfirmedBet[] }) {
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);

  if (roundState === RoundStates.BettingTimeStarted) {
    const data: ICreatePendingBetRequestData = {
      bets: filterEmptyBets(bets),
      timeStamp: new Date().getTime(),
    };

    try {
      const response: ICreatePendingBetResponseData = yield call(() =>
        RestService.createPendingBet(data),
      );

      const totalBet = getBetSum(confirmedBetsToObj(bets));
      yield put(setTotalBetAction(totalBet));
    } catch (error) {
      Sentry.captureException({ error, data });
      const totalBet: number | null = yield select(totalBetSelector);

      if (!totalBet) {
        yield put(clearAllBetsAction());
      }

      console.log(error);
    }
  }
}
